<div #container class="container" *ngIf="vod">
  <div class="title">{{ vodLang?.title }}</div>
  <div class="row" *ngIf="vod.metadata">
    <div *ngIf="vod.metadata.year">{{ vod.metadata.year }}</div>
    <div *ngIf="vod.metadata.duration !== undefined">
      {{ vod.metadata!.duration! | minutesToDuration }}
    </div>
    <div *ngIf="vod.metadata.certificate">{{ vod.metadata.certificate }}</div>
  </div>
  <div *ngIf="vod.metadata?.genres?.length">{{ vod.metadata?.genres?.join(', ') }}</div>
  <div class="description-wrapper">
    <div #description class="description">{{ vodLang?.full }}</div>
  </div>
</div>
